import { Component, OnInit } from "@angular/core";
import { FormGroup, FormBuilder, Validators, FormArray } from "@angular/forms";
import formaPagos from "../../assets/catalogos_sat/c_FormaPago.json";
import metodoPagos from "../../assets/catalogos_sat/c_MetodoPago.json";
import usosCfdi from "../../assets/catalogos_sat/c_UsoCFDI.json";
import { regimenFiscal } from "../catalogos-cfdi";
import { MechanicsApi } from "src/shared/sdk/index.js";
import { Router } from "@angular/router";

@Component({
  selector: "app-crear-factura",
  templateUrl: "./crear-factura.component.html",
  styleUrls: ["./crear-factura.component.scss"],
})
export class CrearFacturaComponent implements OnInit {
  cfdi: FormGroup;
  formaPagos = formaPagos;
  metodoPagos = metodoPagos;
  usosCfdi = usosCfdi;
  claveUnidad = [
    { descripcion: "H87 - Pieza/Unidad", clave: "H87" },
    { descripcion: "XPK - Paquete/Caja", clave: "XPK" },
  ];
  conceptos: FormArray;
  subtotal = [];
  subtotalN = 0;
  productos = [];
  loading = false;
  odoo = [];
  so = false;
  posTicket = false;
  numeroSoFac;
  numeroTicketOdoo;
  invoice;
  ticket;
  serverError;
  regimenFiscal: any = regimenFiscal;

  constructor(
    private fb: FormBuilder,
    private mechanicsApi: MechanicsApi,
    private router: Router
  ) {}

  ngOnInit() {
    this.iniciaCfdi();
  }

  iniciaCfdi() {
    this.cfdi = this.fb.group({
      formaPago: [null, [Validators.required]],
      metodoPago: [null, [Validators.required]],
      receptor_rfc: [
        null,
        [
          Validators.required,
          Validators.pattern(
            "([A-Z&Ñ]{3,4}[0-9]{2}(0[1-9]|1[012])(0[1-9]|[12][0-9]|3[01])[A-Z0-9]{2}[0-9A])|([A-Z&Ñ]{3}[0-9]{2}(0[1-9]|1[012])(0[1-9]|[12][0-9]|3[01])[A-Z0-9]{2}[0-9A])|([A-Z&Ñ]{4}[0-9]{2}(0[1-9]|1[012])(0[1-9]|[12][0-9]|3[01])[A-Z0-9]{2}[0-9A])"
          ),
        ],
      ],
      receptor_nombre: [null, [Validators.required]],
      receptor_email: [null, [Validators.required, Validators.email]],
      cp: [null, [Validators.required]],
      regimenFiscal: [null, [Validators.required]],
      usoCfdi: [null, [Validators.required]],
      subtotal: [0, [Validators.required]],
      iva: [0, [Validators.required]],
      total: [0, [Validators.required]],
      origen: ["MXPFacturas", [Validators.required]],
      tipo: ["MXPFacturas", [Validators.required]],
      conceptos: this.fb.array([]),
    });
    this.serverError = null;
  }

  borraConcepto(i) {
    this.conceptos.removeAt(i);
  }

  creaFactura() {
    this.loading = true;
    this.cfdi.get("subtotal").setValue(this.subtotalN);
    this.cfdi.get("iva").setValue(this.subtotalN * 0.16);
    this.cfdi.get("total").setValue(this.subtotalN * 1.16);
    this.serverError = null;
    console.log(this.cfdi.value);

    this.mechanicsApi.creaFacturaSO(this.cfdi.value).subscribe(
      (cfdi) => {
        console.log(cfdi);
        if (cfdi.status === "error") {
          this.serverError = cfdi;
        } else {
          this.iniciaCfdi();
          this.router.navigate(["/descargasPdfXml/" + cfdi.data.uuid]);
        }
        this.loading = false;
      },
      (err) => {
        this.serverError = err;
      }
    );
  }

  createItem(): FormGroup {
    return this.fb.group({
      descripcion: [null, [Validators.required]],
      clavesProSer: [null, [Validators.required]],
      cantidad: [0, [Validators.required]],
      claveUnidad: [null, [Validators.required]],
      valorUnitario: [0, [Validators.required]],
      importe: [0, [Validators.required]],
    });
  }

  agregaConcepto() {
    this.conceptos = this.cfdi.get("conceptos") as FormArray;
    this.conceptos.push(this.createItem());
    this.odoo.push(false);
  }

  calculaImporte(i) {
    this.subtotal[i] =
      this.cfdi.get("conceptos")["controls"][i].controls.cantidad.value *
      this.cfdi.get("conceptos")["controls"][i].controls.valorUnitario.value;
    this.cfdi
      .get("conceptos")
      ["controls"][i].controls.importe.setValue(this.subtotal[i]);
    this.subtotalN = 0;
    for (let j = 0; j < this.subtotal.length; j++) {
      const sub = this.subtotal[j];
      this.subtotalN += sub;
    }
  }

  obtenProductos(i) {
    if (this.cfdi.get("conceptos")["controls"][i].controls.descripcion.value) {
      this.loading = true;
      this.mechanicsApi
        .obtenProductosOdoo(
          this.cfdi.get("conceptos")["controls"][i].controls.descripcion.value
        )
        .subscribe((productos) => {
          this.productos = productos;
          this.loading = false;
        });
    }
  }

  seleccionado(producto, i) {
    this.cfdi
      .get("conceptos")
      ["controls"][i].controls.descripcion.setValue(producto.display_name);
    this.cfdi
      .get("conceptos")
      ["controls"][i].controls.clavesProSer.setValue(
        producto.x_studio_clave_sat
      );
    this.cfdi
      .get("conceptos")
      ["controls"][i].controls.valorUnitario.setValue(producto.list_price);
    this.cfdi
      .get("conceptos")
      ["controls"][i].controls.claveUnidad.setValue(
        producto.uom_name.split(" ")[0]
      );
  }

  obtenSO() {
    this.loading = true;
    this.serverError = null;
    this.mechanicsApi.obtenSo(this.numeroSoFac).subscribe(
      (invoice) => {
        if (invoice && !invoice.serverError) {
          this.iniciaCfdi();
          this.invoice = invoice;
          this.ticket = null;
          console.log(invoice);
          this.cfdi.get("origen").setValue(this.invoice.id);
          this.cfdi.get("tipo").setValue("invoice");
          this.cfdi.get("receptor_rfc").setValue(this.invoice.receptor.vat);
          this.cfdi.get("receptor_nombre").setValue(this.invoice.receptor.name);
          this.cfdi.get("receptor_email").setValue(this.invoice.receptor.email);
          this.cfdi.get("cp").setValue(this.invoice.receptor.zip);
          this.cfdi
            .get("regimenFiscal")
            .setValue(
              this.invoice.receptor &&
                this.invoice.receptor.x_studio_regimen_fiscal
                ? this.invoice.receptor.x_studio_regimen_fiscal.split(" ")[0]
                : ""
            );
          for (let i = 0; i < this.invoice.lines.length; i++) {
            const linea = this.invoice.lines[i];
            if (
              typeof this.cfdi.get("conceptos")["controls"][i] === "undefined"
            )
              this.agregaConcepto();
            this.cfdi
              .get("conceptos")
              ["controls"][i].controls.descripcion.setValue(
                linea.product_id ? linea.product_id[1] : linea.display_name
              );
            this.cfdi
              .get("conceptos")
              ["controls"][i].controls.clavesProSer.setValue(
                linea.x_studio_clave_sat ? linea.x_studio_clave_sat : "52151600"
              );
            this.cfdi
              .get("conceptos")
              ["controls"][i].controls.valorUnitario.setValue(linea.price_unit);
            this.cfdi
              .get("conceptos")
              ["controls"][i].controls.cantidad.setValue(linea.quantity);
            this.cfdi
              .get("conceptos")
              ["controls"][i].controls.clavesProSer.setValue(linea.sat);
            this.cfdi
              .get("conceptos")
              ["controls"][i].controls.claveUnidad.setValue(
                linea.uom_id ? linea.uom_id[1].split(" ")[0] : ""
              );
            this.calculaImporte(i);
          }
        } else {
          this.serverError = invoice.serverError;
        }
        this.loading = false;
      },
      (err) => {
        this.serverError = err;
        console.log(err);
      }
    );
  }

  obtenTicketOdoo() {
    this.loading = true;
    this.serverError = null;
    this.mechanicsApi
      .obtenTicketOdoo("Orden " + this.numeroTicketOdoo)
      .subscribe(
        (ticket) => {
          if (ticket && !ticket.serverError) {
            this.iniciaCfdi();
            console.log(ticket);
            this.ticket = ticket;
            this.invoice = null;
            this.cfdi.get("origen").setValue(this.ticket.id);
            this.cfdi.get("tipo").setValue("ticket");
            if (this.ticket.cliente) {
              this.cfdi.get("receptor_rfc").setValue(this.ticket.cliente.vat);
              this.cfdi
                .get("receptor_nombre")
                .setValue(this.ticket.cliente.name);
              this.cfdi
                .get("receptor_email")
                .setValue(this.ticket.cliente.email);
              this.cfdi.get("cp").setValue(this.ticket.cliente.zip);
              this.cfdi
                .get("regimenFiscal")
                .setValue(
                  this.ticket.cliente.x_studio_rgimen_fiscal
                    ? this.ticket.cliente.x_studio_rgimen_fiscal.split(" ")[0]
                    : ""
                );
            }
            for (let i = 0; i < this.ticket.lineas.length; i++) {
              const linea = this.ticket.lineas[i];
              if (
                typeof this.cfdi.get("conceptos")["controls"][i] === "undefined"
              )
                this.agregaConcepto();
              this.cfdi
                .get("conceptos")
                ["controls"][i].controls.descripcion.setValue(
                  linea.display_name
                );
              this.cfdi
                .get("conceptos")
                ["controls"][i].controls.clavesProSer.setValue(
                  linea.x_studio_clave_sat && linea.x_studio_clave_sat[1]
                    ? linea.x_studio_clave_sat[1].split("_")[0].trim()
                    : "52151600"
                );
              this.cfdi
                .get("conceptos")
                ["controls"][i].controls.valorUnitario.setValue(
                  linea.price_unit
                );
              this.cfdi
                .get("conceptos")
                ["controls"][i].controls.cantidad.setValue(linea.qty);
              this.cfdi
                .get("conceptos")
                ["controls"][i].controls.claveUnidad.setValue(
                  linea.product_udm[1].split(" ")[0]
                );
              this.calculaImporte(i);
            }
          } else {
            this.serverError = ticket.serverError;
          }
          this.loading = false;
        },
        (err) => {
          this.serverError = err;
          console.log(err);
        }
      );
  }

  inicializaCfdi() {
    if ((!this.so && this.invoice) || (!this.posTicket && this.ticket)) {
      window.location.reload();
    }
  }
}
